import { Image as TiptapImage } from "@tiptap/extension-image"

type Align = "left" | "center" | "right" | "justify" | null

export const AlignableImage = TiptapImage.extend({
  name: "image",
  inline: false,
  group: "block",
  draggable: true,

  addAttributes() {
    // TS não tipa `parent` — usamos um cast leve
    const parentAttrs =
      ((this as unknown as { parent?: () => Record<string, any> }).parent?.() as
        | Record<string, any>
        | undefined) ?? {}

    return {
      ...parentAttrs,
      textAlign: {
        default: null as Align,
        parseHTML: (element: HTMLElement) =>
          (element.getAttribute("data-align") as Align) ?? null,
        renderHTML: (attributes: { textAlign?: Align }) => {
          const textAlign = attributes?.textAlign ?? null
          const style: string[] = []

          if (textAlign === "left") {
            style.push("display:block", "margin:0", "margin-right:auto", "float:none")
          } else if (textAlign === "center") {
            style.push("display:block", "margin-left:auto", "margin-right:auto", "float:none")
          } else if (textAlign === "right") {
            style.push("display:block", "margin-left:auto", "margin-right:0", "float:none")
          } else if (textAlign === "justify") {
            // justify não se aplica a <img>; trate como center
            style.push("display:block", "margin-left:auto", "margin-right:auto", "float:none")
          }

          return {
            "data-align": textAlign ?? null,
            style: style.join("; "),
          }
        },
      },
    }
  },
})
